<div class="button-container" (focusin)="onFocusIn()" (focusout)="onFocusOut($event)">
    <button class="left" [class.disabled]="_disabled" [disabled]="_disabled" type="button" (click)="onChange(true)" [class.active]="_value === true">Yes</button>
    <button class="right" [class.disabled]="_disabled" [disabled]="_disabled" type="button" (click)="onChange(false)" [class.active]="_value === false">No</button>
</div>
